import { IGetWallet, NFTI } from '@tacans/shared-marketplace-layer';
import { useCallback } from 'react';
import { useFetchCollectionsList } from 'src/features/common/collection/hooks/use-collections-list';
import { useFetchUserList } from 'src/features/common/user/hooks/user-list.hooks';
import { getNftTypeByStandard } from 'src/utils/lot.utils';

export const useFetchDataForNftCards = () => {
    const fetchCollections = useFetchCollectionsList();
    const fetchUserList = useFetchUserList();

    return useCallback(
        (items: NFTI[]) => {
            const collectionsToFetch: string[] = [];
            const usersToFetch: IGetWallet[] = [];

            items.forEach((item) => {
                if (!item) {
                    return;
                }
                if (item.collectionId) {
                    collectionsToFetch.push(item.collectionId);
                    return;
                }
                const { isSingle } = getNftTypeByStandard(item.standard);
                usersToFetch.push({
                    address: isSingle ? item.owner : item.author,
                    blockchainId: item.blockchainId,
                });
            });

            fetchCollections({ ids: collectionsToFetch });
            fetchUserList({
                wallets: usersToFetch,
            });
        },
        [fetchCollections, fetchUserList]
    );
};
